import posthog from "posthog-js";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import blogBot from "./app/assets/images/botblogrLogo.png";

function Fallback({ error, resetErrorBoundary }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="min-h-dvh w-full  bg-darkgray text-white">
      <div className="flex   min-h-dvh flex-col items-center justify-center">
        <div className="w-full md:max-w-lg lg:max-w-3xl text-center">
          <div className="my-5">
            <div className="flex justify-center">
              <img
                alt="Your Company"
                src={blogBot}
                className="h-20 w-auto my-10"
              />
            </div>
            <p className="text-2xl md:text-4xl lg:text-6xl">
              {t("Oooops", "Oooops")}!..
            </p>
            <p className="text-lg md:text-2xl lg:text-4xl mt-3">
              {t("Something-is-not-right", "Something is not right")}
            </p>
            <p className="text-red-700 text-sm md:text-lg lg:text-xl mt-3">
              {error.message}
            </p>
          </div>
          <a
            href="/login"
            className="bg-blue-200 hover:bg-blue-100 text-white rounded-md px-5 py-2 mt-14 text-xs"
          >
            Back to home
          </a>
        </div>
      </div>
    </div>
  );
}

function App() {
  const location = useLocation();
  const { userInfo } = useSelector((state) => state?.auth);
  const searchParams = new URLSearchParams(location.search);
  const uid = searchParams.get("uid");
  const utm_source = searchParams.get("utm_source");
  const utm_medium = searchParams.get("utm_medium");
  const utm_campaign = searchParams.get("utm_campaign");
  const utm_term = searchParams.get("utm_term");
  const utm_content = searchParams.get("utm_content");

  useEffect(() => {
    posthog.capture("$pageview", { path: location.pathname });

    if (uid && userInfo === null) {
      posthog.identify(uid);
    }
  }, [location.pathname]);

  // Stocker les utms pour le tracking
  useEffect(() => {
    if (utm_source || utm_medium || utm_campaign) {
      const utm_data = {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content,
      };
      localStorage.setItem("utm_data", JSON.stringify(utm_data));
    }
  }, []);

  // Identify user in posthog if connected
  useEffect(() => {
    if (userInfo?.user_id) {
      const anonymousId = posthog.get_distinct_id();

      // Ne faire alias que si l'anonymous ID est différent
      if (anonymousId !== userInfo.user_id.toString()) {
        posthog.alias(userInfo.user_id, anonymousId);
      }

      posthog.identify(userInfo.user_id, {
        email: userInfo.email,
        name: userInfo.username,
        plan: userInfo.plan,
      });
    }
  }, [userInfo]);

  return (
    <>
      <ErrorBoundary FallbackComponent={Fallback}>
        <Outlet />
      </ErrorBoundary>

      <ToastContainer />
    </>
  );
}

export default App;
